import React from 'react';
import { Grid, Typography } from '@mui/material';

const SectionForm = ({ title, subtitle, children }) => {
  return (
    <Grid
      container
      spacing={2}
      className="custom-input"
      sx={{ padding: '10px 0', borderBottom: 'solid 1px #EAECF0', paddingBottom: '25px' }}
    >
      <Grid item xs={3} sx={{ padding: '26px 16px !important' }} className="section-title">
        <Typography variant="h4" sx={{ fontSize: '18px' }}>
          {title}
        </Typography>
        <span style={{color: '#667085', fontWeight: 300, fontSize: '14px'}}>{subtitle}</span>
      </Grid>
      <Grid item xs={9}>
        {children} {/* Render children components here */}
      </Grid>
    </Grid>
  );
};

export default SectionForm;